import { render, staticRenderFns } from "./DevComponentInfoBox.vue?vue&type=template&id=72c3928a&scoped=true"
import script from "./DevComponentInfoBox.vue?vue&type=script&lang=js"
export * from "./DevComponentInfoBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c3928a",
  null
  
)

export default component.exports